import { Reducer } from 'redux';
import { ChannelsActionTypes, StatisticsChannelsState } from './types';

const defaultState = {
    loading: false,
    singleChannelLoading: false,
    activePage: 1,
    perPage: 10,
    search: null,
};

const reducer: Reducer<StatisticsChannelsState> = (
    state: StatisticsChannelsState = defaultState,
    action
): StatisticsChannelsState => {
    const { payload, type } = action;
    switch (type) {
        case ChannelsActionTypes.LOAD_ALL:
            return {
                ...state,
                loading: true,
            };
        case ChannelsActionTypes.LOAD_ALL_ERROR:
            return {
                ...state,
                loading: false,
            };
        case ChannelsActionTypes.LOAD_ALL_SUCCESS:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
};

export { reducer as channels };

export default reducer;
